import {cn} from '@/lib/utils';
import guests from '../../../public/guests.png';
import Image from 'next/image';
import GalleryIcon from '../Icons/Gallery';
import EmptyStarIcon from '../Icons/EmptyStar';

type Props = {
  displayingMap: boolean;
};

export default function VillageCardLoader({displayingMap}: Props) {
  return (
    <div
      className={cn(
        'w-full md:w-[calc(50%-1.875rem)] md:mx-[0.9375rem] [@media(min-width:1700px)]:w-[calc(33.33333%-1.875rem)] 3xl:w-[calc(25%-1.875rem)] animate-pulse',
        {
          'desktop:w-[calc(100%-1.875rem)] [@media(min-width:1700px)]:w-[calc(100%-1.875rem)] 3xl:w-[calc(100%-1.875rem)]':
            displayingMap,
        },
      )}>
      <article className="inline-block w-full bg-white mb-4 shadow-default md:mb-[1.875rem] desktop:hover:shadow-[0_10px_20px_0_rgba(0,0,0,.3)] desktop:transition-shadow desktop:duration-300">
        <a className="block cursor-default" target="_self" href="#">
          <div className="w-full h-[420px] relative overflow-hidden">
            <div className="bg-gray-100 w-full h-full"></div>
            <div className="absolute left-0 bottom-0 w-full h-[90px] overflow-hidden before:content-[''] before:absolute before:left-0 before:bottom-0 before:w-full before:h-full before:bg-black/30 before:backdrop-blur-[2px]">
              <div className="relative h-[90px] p-[15px] text-white">
                <ul className="float-right list-none mx-[-16px] py-[10px]">
                  <li className="inline-block mx-[16px]">
                    <button className="hidden desktop:block relative z-[1] cursor-pointer appearance-none bg-transparent border-0">
                      <GalleryIcon className="w-8 h-[32px] fill-current text-white" />
                    </button>
                  </li>
                  <li className="inline-block mx-[16px]">
                    <button className="relative z-[1] cursor-pointer appearance-none bg-transparent border-0">
                      <EmptyStarIcon className="w-8 h-[32px] fill-current text-white" />
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="bg-white text-graphite p-[15px]">
            <div className="flex flex-col flex-wrap desktop:flex-row">
              <div className="text-base leading-[1.62] text-left">
                <span className="font-noe-regular">
                  From{' '}
                  <span className="whitespace-nowrap text-2xl font-bold leading-[1.38] font-title">
                    {`€ 0`}
                  </span>
                  /per week
                </span>
              </div>
              <ul className="mx-[-12px] list-none py-[4px] flex desktop:ml-auto">
                <li className="flex items-center mx-[12px]">
                  <Image src={guests} alt="Guests icon image" />
                  <span className="ml-[4px] text-white">0</span>
                </li>
                <li className="flex items-center mx-[12px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="20"
                    viewBox="0 0 24 20">
                    <path
                      fill="#CCC"
                      fillRule="evenodd"
                      d="M22 10.444c1.737.768 2 1.556 2 1.556v8h-2v-2H2v2H0v-8s.263-.788 2-1.556V0h2v3h16V0h2v10.444zm-2-.666V5h-7v4.009c3.138.054 5.389.366 7 .769zm-16 0c1.611-.403 3.862-.715 7-.77V5H4v4.778zM22 16v-3s-2-2-10-2-10 2-10 2v3h20z"
                    />
                  </svg>

                  <span className="ml-[4px] text-white">0</span>
                </li>
                <li className="flex items-center mx-[12px]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="20"
                    viewBox="0 0 24 20">
                    <path
                      fill="#CCC"
                      fillRule="nonzero"
                      d="M11 5.998a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM13 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM9 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm8 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm7 2v2h-2v1c0 1.89-1.235 3.584-3 4l1 2h-2l-1-2H7l-1 2H4l1-2c-1.765-.416-3-2.11-3-4v-1H0v-2h20V3c0-.551-.449-1-1-1h-5v1h-2V0h7c1.654 0 3 1.346 3 3v8h2zm-4 3v-1H4v1c0 1.102.897 2 2 2h12c1.103 0 2-.898 2-2z"
                    />
                  </svg>
                  <span className="ml-[4px] text-white">0</span>
                </li>
              </ul>
            </div>
            <div className="bg-gray-100 w-full min-h-[40px] mt-[20px] text-center text-sm leading-[1.71] rounded-[5px] text-gray-400 py-[8px] px-[10px] [&>:not(:first-child)]:before:content-['/'] [&>:not(:first-child)]:before:inline-block [&>:not(:first-child)]:before:mx-[8px]" />
          </div>
        </a>
      </article>
    </div>
  );
}
